// ============================================
// 📱 APP: NVA (React App)
// 📄 FILE: src/components/chat/ChatRelogin.tsx
// 🔧 PURPOSE: "Accedi di nuovo" quando chi apre la chat non ha un suo login
//             da offrire (Il mio soggiorno): il login di sempre
//             (GuestLoginModal) sopra la chat, con codice ed email della
//             sessione scaduta già scritti. Riuscito l'accesso la sessione
//             nuova arriva a tutta l'app, la chat riceve il token nuovo e
//             ricarica la conversazione: si resta nella chat.
//             Si monta solo quando serve (il login apre anche l'ascolto
//             delle notifiche per il deviceId, come negli altri login).
// ============================================

import React, { useEffect, useState } from 'react';
import GuestLoginModal from '../GuestLoginModal';
import { useGuestSession } from '../../hooks/useGuestSession';
import { useNotifications } from '../../hooks/useNotifications';

const ChatRelogin: React.FC<{ onClose: () => void }> = ({ onClose }) => {
  const { booking, login, isLoading, error, errorCode, clearError } = useGuestSession();
  const { deviceId } = useNotifications();
  // Presi una volta all'apertura: la sessione scaduta è ancora salvata.
  const [prefill] = useState(() => ({
    bookingReference: booking?.bookingReference || '',
    email: booking?.guestEmail || '',
  }));

  // Un errore di un tentativo vecchio non si rivede.
  useEffect(() => {
    clearError();
  }, [clearError]);

  return (
    <GuestLoginModal
      isOpen
      onClose={onClose}
      onLogin={(bookingReference, email) => login(bookingReference, email, deviceId)}
      isLoading={isLoading}
      error={error}
      errorCode={errorCode}
      redirectToChat
      initialBookingReference={prefill.bookingReference}
      initialEmail={prefill.email}
    />
  );
};

export default ChatRelogin;
